/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SaveNoteSettingsRequest {
  kiloEuros?: boolean
  referenceAmount?: SaveNoteSettingsRequestReferenceAmountEnum
  assujettiImpotsSocietes?: boolean
  impotsSurBeneficeComputed?: boolean
  prelevementTnsInCr?: boolean
  showDemarrage?: boolean
  showDetailPret?: boolean
  showPercentageCedant?: boolean
  showPercentagePrevisionnel?: boolean
  showBfrInverse?: boolean
  showPreviousPeriod?: boolean
  expandedDetailKeys?: Array<string>
}

export const SaveNoteSettingsRequestReferenceAmountEnum = {
  NONE: "NONE",
  CHIFFRE_AFFAIRE: "CHIFFRE_AFFAIRE",
  PRODUITS_EXPLOITATION: "PRODUITS_EXPLOITATION"
} as const

export type SaveNoteSettingsRequestReferenceAmountEnum =
  (typeof SaveNoteSettingsRequestReferenceAmountEnum)[keyof typeof SaveNoteSettingsRequestReferenceAmountEnum]
